
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire05d0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire05d0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bCIFA", function(module, exports) {

$parcel$export(module.exports, "register", () => $8765e4c924822d27$export$6503ec6e8aabbaf, (v) => $8765e4c924822d27$export$6503ec6e8aabbaf = v);
var $8765e4c924822d27$export$6503ec6e8aabbaf;
var $8765e4c924822d27$export$f7ad0328861e2f03;
"use strict";
var $8765e4c924822d27$var$mapping = new Map();
function $8765e4c924822d27$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8765e4c924822d27$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8765e4c924822d27$var$resolve(id) {
    var resolved = $8765e4c924822d27$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8765e4c924822d27$export$6503ec6e8aabbaf = $8765e4c924822d27$var$register;
$8765e4c924822d27$export$f7ad0328861e2f03 = $8765e4c924822d27$var$resolve;

});

var $05b4baced52ced5c$exports = {};

(parcelRequire("bCIFA")).register(new URL("", import.meta.url).toString(), JSON.parse('["13Jy0","index.31eb1ac9.js","8SGZd","Resume-Nimesh-Solanki.959e05ee.pdf","bKYiK","Voice.bef5abc0.webp","j3sO2","risingStar.a33c9d4f.jp2","fIKBM","bixbyPD.f798b52b.jp2","03Rtp","gdgahm.159e4283.jp2","hFB3s","alexa.f8e16f27.jp2","f4Gw0","nodejs-icon.214200e2.svg","fPCIe","twilio.910daab2.jp2","5c4Ea","aws.75714d15.jp2","eCfJQ","BigBasketIcon.f9f6f9e5.jp2","0lPRz","chrome-dev.36105eb8.jp2","fsica","firebase.c9642a39.jp2","6rlox","dialogflow.9d81299f.jp2","kdy2Y","momentjs.bc64f63c.jp2","fyJBO","bixbyIcon.8d2878ce.jp2","j8Cqo","bixby.a1c0d438.jp2","f0L6D","AoG.f6d9acda.gif"]'));


//# sourceMappingURL=index.runtime.13962199.js.map
